
























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Category as ICategory } from "@/api-v2/category/models/category";
import api, { categoryApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import Modal from "@/components/form/Modal.vue";
@Component({
  components: { Modal }
})
export default class CategoryItem extends Vue {
  @Prop() category!: ICategory;
  @Prop() index!: number;
  title!: string;
  description?: string;
  showEditDetail: boolean = false;

  data() {
    return {
      title: undefined,
      description: undefined
    };
  }

  mounted() {
    if (this.category) {
      //@ts-ignore
      this.title = this.category.title;
      this.description = this.category.description;
    }
  }

  applyChange() {
    let params: ICategory = {
      title: this.title,
      description: this.description
    };
    if (this.category && this.category.id) {
      categoryApi.category
        .editCategory(this.category.id, params)
        .then(() => {
          this.showEditDetail = false;
          this.$emit("update");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  deleteItem(category: string) {
    categoryApi.category
      .deleteCategory(category)
      .then(() => {
        this.showEditDetail = false;
        this.$emit("updateList", category);
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
  @Watch("description")
  replaceExcess() {
    let excessY = "</p>";
    let excessX = "<p>";
    this.description = this.description?.replace(excessY, "");
    this.description = this.description?.replace(excessX, "");
  }
}
